import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { isAuthenticated } from '../utils/auth';
import { Home, Compass } from 'lucide-react';

/**
 * 404 page — prevents React Router from rendering an empty page when the
 * URL doesn't match any defined route (e.g. a typo, a stale bookmark, a
 * deeplink from an older build).
 */
const NotFound = () => {
  const { isDarkMode } = useTheme();
  const homePath = isAuthenticated() ? '/dashboard' : '/';

  return (
    <div className={`min-h-screen flex items-center justify-center p-6 ${isDarkMode ? 'bg-[#050508]' : 'bg-slate-50'}`}>
      <div className={`max-w-md w-full text-center ${isDarkMode ? 'bg-white/5 border border-white/10' : 'bg-white border border-slate-200'} rounded-2xl p-8`}>
        <Compass className={`w-12 h-12 mx-auto mb-4 ${isDarkMode ? 'text-cyan-400' : 'text-cyan-600'}`} />
        <h1 className={`text-3xl font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>404</h1>
        <p className={`text-sm mb-6 ${isDarkMode ? 'text-white/70' : 'text-slate-600'}`}>
          The page you're looking for doesn't exist, or it moved in a recent update.
        </p>
        <Link
          to={homePath}
          className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500 hover:bg-cyan-400 text-white rounded-lg text-sm font-medium"
          data-testid="404-home-link"
        >
          <Home className="w-4 h-4" /> Back to {isAuthenticated() ? 'Dashboard' : 'Home'}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
